import React from "react";
import { FormControl, Grid, InputLabel, MenuItem, Select } from "@mui/material";

interface DefaultCurrencyProps {
  settingName: string;
  settingValue: string;
  handleUpdate: (settingValue: string) => void;
}

const DefaultCurrency: React.FC<DefaultCurrencyProps> = ({ settingName, settingValue, handleUpdate }) => {
  return (
    <Grid container display="flex" alignItems="center" spacing={1} size={12}>
      <FormControl fullWidth>
        <InputLabel id="currency-label">Currency Symbol</InputLabel>
        <Select
          labelId="currency-label"
          id="currency-select"
          value={settingValue || "£"}
          label={settingName}
          onChange={(event) => handleUpdate(event.target.value)}
        >
          <MenuItem value="£">GBP (£)</MenuItem>
          <MenuItem value="€">EUR (€)</MenuItem>
          <MenuItem value="$">USD ($)</MenuItem>
        </Select>
      </FormControl>
    </Grid>
  );
};

export default DefaultCurrency;
